export enum AiAgentWsEvent {
  GENERATED = 'ai_agent_generated',
  GENERATION_FAILED = 'ai_agent_generation_failed',
}
